import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List } from "immutable";
import * as React from "react";
import { partition } from "../../util";
import { Block } from "../library/container";
import { Loader } from "../loader";
import { loadFormstackForm } from "./formstack_api";
const initialState = {
    form: {
        kind: null,
        status: null
    }
};
export const formstackBlockClasses = {
    blockClassName: 'block block--form',
    innerClassName: 'block__inner',
    contentClassName: 'block__content'
};
let isMounted = false;
let previousFormHeight = -1;
export class InnerHTML extends React.Component {
    componentWillUnmount() {
        isMounted = false;
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            ref: async (divRef)=>{
                if (!this.props.html || !divRef || (divRef === null || divRef === void 0 ? void 0 : divRef.innerHTML) != '') return;
                divRef.innerHTML = ''; // Clear the container
                var targetDiv = document.createElement('div');
                var parsedDocument = new DOMParser().parseFromString(this.props.html, "text/html");
                var body = parsedDocument.getElementById('fsLocal');
                var form = parsedDocument.getElementsByTagName('form');
                form[0].setAttribute('autocomplete', 'on');
                // Insert classname if necessary below
                targetDiv.className = body.className + " example-classname";
                targetDiv.id = body.id;
                targetDiv.innerHTML = body.innerHTML;
                const links = List(parsedDocument.getElementsByTagName('link'));
                const promises = links.map((link)=>new Promise((resolve)=>link.onload = ()=>resolve(link.href))).toArray();
                links.forEach((link)=>divRef.appendChild(link));
                // Prepare copy of live Element list
                const copy_scripts = List(targetDiv.getElementsByTagName('script'));
                // Remove scripts from initial html (done by reference)
                copy_scripts.forEach((x)=>x.remove());
                // When all external CSS has loaded, add the processed form div to the DOM
                await Promise.all(promises).then(()=>divRef.appendChild(targetDiv));
                // Load the scripts, first external then inline scripts
                const [linkedScripts, inlineScripts] = partition(copy_scripts, (x)=>{
                    var _x_src;
                    return ((_x_src = x.src) === null || _x_src === void 0 ? void 0 : _x_src.length) > 1;
                });
                const scriptLoaders = linkedScripts.map((x)=>new Promise((resolve, reject)=>{
                        const s = document.createElement('script');
                        s.src = x.src;
                        s.async = false;
                        s.onload = (_)=>resolve(s.src);
                        s.onerror = (_)=>reject(s.src);
                        divRef.firstChild.appendChild(s);
                    })).toArray();
                // Wait for external scripts to load
                await Promise.all(scriptLoaders).catch((src)=>console.error("failed to load", src));
                // Append inline scripts
                inlineScripts.forEach((x)=>{
                    const s = document.createElement('script');
                    s.text = x.text;
                    divRef.firstChild.appendChild(s);
                });
                // Execute formstack library function to initialize form
                window.loadFormstack();
            // Scrolling logic
            // let checkHeight = () => setTimeout(() => {
            //   if (!isMounted) return
            //   let formDiv: HTMLElement = document.querySelector('#fsLocal')
            //   let currentHeight = formDiv.offsetHeight
            //   if (previousFormHeight == -1) { previousFormHeight = currentHeight }
            //   if (previousFormHeight != currentHeight) {
            //     // scrollTo
            //     formDiv.scrollIntoView(false)
            //   }
            //   previousFormHeight = currentHeight
            //   checkHeight()
            // }, 500)
            // checkHeight()
            }
        });
    }
    constructor(prop){
        super(prop);
        this.state = {};
        isMounted = true;
        previousFormHeight = -1;
    }
}
export class FormstackBlock extends React.Component {
    componentDidMount() {
        loadFormstackForm(this.props.formId).then((result)=>this.setState((prevState)=>({
                    ...prevState,
                    form: result
                })));
    }
    render() {
        const form = this.state.form;
        if (form.kind == null) return /*#__PURE__*/ _jsx(Block, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "form form--formstack form--formstack-loading",
                children: [
                    "Het formulier wordt geladen...",
                    /*#__PURE__*/ _jsx(Loader, {})
                ]
            })
        });
        if (form.kind == 'result') return /*#__PURE__*/ _jsx(Block, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "form form--formstack form--formstack-loaded",
                children: /*#__PURE__*/ _jsx(InnerHTML, {
                    html: form.value.html
                })
            })
        });
        return /*#__PURE__*/ _jsx(Block, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "form form--formstack form--formstack-failed",
                children: "Het formulier kon helaas niet geladen worden. Herlaad de pagina of neem contact op met De Bibliotheek AanZet."
            })
        });
    }
    constructor(props){
        super(props);
        this.state = initialState;
    }
} // const myComponent = (p: FormstackBlockProps): Widget<Action<FormstackBlockProps>> =>
 //   any<Action<FormstackBlockProps>>()([
 //     fromJSX(_ => <Block>
 //       <div className="form form--formstack">
 //         {
 //           p.state.kind == "loaded" &&
 //           <InnerHTML html={p.state.value.html} />
 //         }
 //       </div>
 //     </Block>)
 //   ])
 // export const FormstackBlock: (props: FormstackBlockProps) => JSX.Element = p => myComponent(p).run(() => console.log('Tadaa! 🎉'))
 // export const FormstackBlock: (props: FormstackBlockProps) => JSX.Element = p => (
 //   <Block>
 //     <div className="form form--formstack">
 //       {
 //         p.state.kind == "loaded" &&
 //         <InnerHTML html={p.state.value.html} />
 //       }
 //     </div>
 //   </Block>
 // )
 // export function FormstackBlock(
 //   props: FormstackBlockProps,
 //   options?: { style: FormstackBlockStyle; key?: string }
 // ): (s: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>> {
 //   return (s: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
 //     mk_widget({
 //       run: setState => {
 //         function setBlockState<K extends keyof FormstackBlockProps>(key: K, newValue: FormstackBlockProps[K]) {
 //           return (s1: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>): CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData> => {
 //             let current_block = s.blocks.get(props.blockIndex)
 //             if (current_block.kind != 'formstackBlock') return s1
 //             current_block = ({
 //               ...current_block,
 //               value: {
 //                 ...current_block.value,
 //                 fst: {
 //                   ...current_block.value.fst,
 //                   [key]: newValue
 //                 }
 //               }
 //             })
 //             return ({ ...s1, blocks: s1.blocks.set(props.blockIndex, current_block) })
 //           }
 //         }
 //         return (
 //           <section className={getClassName(options, "blockClassName", "form container--m gutter--m")}>
 //             {async<FormstackForm>()(props.state).run(a => setState(setBlockState('state', a((s.blocks.get(props.blockIndex) as any).value.fst.state))))}
 //             {props.state.kind == "loaded" ?
 //               <InnerHTML html={props.state.value.html} />
 //               : null
 //             }
 //           </section>
 //         )
 //       }
 //     })
 // }
